import {basePath} from "../constants/public-routes";

export default {
  locale: "fr",

  messages: {
    "about": "concernent ce site web",
    "aboutMenu": "À propos",
    "aboutThisText": "À propos de ce texte",
    "addedtoPrint": "Ajouté à la liste d'impression",
    "addPrint": "Ajouter à la liste d'impression",
    "advancedSearch": "Recherche avancée",
    "advancedSearching": "Plus d'options de recherche",
    "alsoLookedFor": "Il a également été recherché sur la base de",
    "annotatedTexts": "Textes législatifs",
    "toTheAnnotatedTexts": "accès aux textes législatifs",
    "annotation": "Annotation",
    "annotationOf": "Annotation de",
    "annotations": "Annotations",
    "annotationsBack": "Vers les annotations",
    "annotationsOf": "Annotations de",
    "anyQuestions": "Vous avez des questions ou des remarques? Envoyez-les via ce formulaire.",
    "arrest": "Jurisprudence et avis",
    "arrests": "Jurisprudence et avis",
    "article": "Article",
    "articleNumber": "Numéro d'article",
    "author": "Auteur",
    "back": "Retour",
    "backToLastSearch": "Répéter dernière recherche",
    "backToPrevious": "Retour à la page précédente",
    "belgianSenate": "Sénat de Belgique",
    "changeDate": "Date de modification",
    "clear": "Vider",
    "clearOptions": "Effacer options",
    "comment": "Commentaire",
    "comments": "Commentaire",
    "contact": "",
    "currentLanguage": "Langue consultée",
    "currentVersion": "Version consultée",
    "dateAnnounced": "Publication",
    "dateConfirmed": "Promulgation",
    "dateEffective": "Entrée en vigueur",
    "dateVersion": "Version",
    "de": "Allemand",
    "dia": "SenLex",
    "diaIntro": "<p>La banque de données SenLex est un recueil d'informations officielles sur la réglementation institutionnelle belge.  Cette banque de données a compilé pour vous la Constitution et les principales normes institutionnelles, en y ajoutant, classés par article, des extraits pertinents des travaux parlementaires préparatoires, de la jurisprudence de la Cour constitutionnelle et des avis du Conseil d'État. Vous pouvez y consulter les textes de la réglementation institutionnelle tels qu'ils existaient au moment de l'entrée en vigueur de la sixième réforme de l'État au 1er juillet 2014, ainsi que les modifications apportées ultérieurement.</p><p><a href='fr/about'>Plus d'infos</a>.</p>",
    "differentLanguages": "Autres langues",
    "dutch": "Néerlandais",
    "effectiveDate": "Date entrée en vigueur",
    "element": "Élément",
    "Email": "Adresse mail",
    "findThis": "Cherchez ceci",
    "firstArticle": "premier article",
    "foundCategory": "Catégorie",
    "foundTag": "descripteur",
    "fr": "Français",
    "french": "Français",
    "from": "de",
    "german": "Allemand",
    "hideAdvancedSearching": "Moins d'options de recherche",
    "history": "Historique législatif",
    "home": "Page d'accueil",
    "indexBack": "Vers l'index",
    "language": "Langue",
    "lastArticle": "dernier article",
    "law": "Loi",
    "lawTexts": "Textes législatifs",
    "message": "votre question ou remarque",
    "Message": "Message",
    "Name": "Nom",
    "next": "suivant",
    "nl": "Néerlandais",
    "noStructureLabel": "[Basiswet] (FR)",
    "noVersions": "Il n'y en a pas d'autres versions",
    "onlyOneArticleVersion": "Cet article n'a pas été modifié depuis l'introduction de SenLex",
    "noXFound": "Pas de {subjet} trouvé",
    "or": "ou",
    "otherVersions": "Versions",
    "overview": "Vue d'ensemble",
    "pref": "Travaux parlementaires",
    "prefs": "Travaux parlementaires",
    "previous": "précédent",
    "previousVersions": "Versions précédentes",
    "print": "Imprimer",
    "printQueue": "Liste d'impression",
    "publication": "Publications",
    "query": "Demande de recherche",
    "quoteTip": "La recherche porte sur le mot exact ou sur la combinaison de mots exacte. <br/>Les wild cards suivantes peuvent être utilisées :<br/>" +
    "- \"?\" : remplace un caractère<br/>" +
    "- \"*\" : remplace 0, un ou plusieurs caractères.",
	"read": "Lire",
    "readOn": "Lire la suite",
    "recentChanges": "Adaptations récentes",
    "ref": "Voir aussi ",
    "refs": "Voir aussi ",
    "relevant": "Réglementation pertinente",
    "search": "Recherche",
    "searchResults": "Résultats",
    "searchTerm": "Mots dans le texte ",
    "send message": "Envoyer message",
    "show message": "Montrer message",
    "Senlex": "Senlex",
    "showingXofY": "{start, number} - {end, number}",
    "showLess": "Montrez moins",
    "showMore": "Montrez plus",
    "simpleSearch": "Recherche simple",
    "source": "Source",
    "stay-informed-latest": "Restez informé des modifications les plus récentes",
    "structure": "Texte législatif",
    "subject": "sujet",
    "Subject": "Sujet",
    "tableOfContents": "Table des matières",
    "tagIndex": "accès au régistre des mots-clés",
    "tags": "Mots-clés",
    "text": "Texte",
    "tooManyResults": "De nombreux résultats ont été trouvés, ce qui signifie que tous les résultats ne peuvent pas être affichés. Veuillez affiner les critères de recherce.",
    "type": "Type d'information",
    "typeSearch": "Indiquez ici le mot recherché",
    "typeTags": "Indiquez ici un ou plusieurs mots-clés",
    "weWillAnswer": "Les collaborateurs de SenLex tâcheront d'y répondre dans les meilleurs délais. Attention: le Sénat ne fournit pas de conseils juridiques.",
    "your email adress": "votre adresse mail"
  }
};



/** WEBPACK FOOTER **
 ** ./src/i18n/fr.js
 **/